"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ExplanationOfBenefit_SupportingInfo = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Attachment_1 = require("./RTTI_Attachment");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Coding_1 = require("./RTTI_Coding");
exports.RTTI_ExplanationOfBenefit_SupportingInfo = t.recursion('IExplanationOfBenefit_SupportingInfo', function () {
    return t.intersection([
        t.type({
            category: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            sequence: RTTI_positiveInt_1.RTTI_positiveInt,
            _sequence: RTTI_Element_1.RTTI_Element,
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            timingDate: t.string,
            _timingDate: RTTI_Element_1.RTTI_Element,
            timingPeriod: RTTI_Period_1.RTTI_Period,
            valueBoolean: t.boolean,
            _valueBoolean: RTTI_Element_1.RTTI_Element,
            valueString: t.string,
            _valueString: RTTI_Element_1.RTTI_Element,
            valueQuantity: RTTI_Quantity_1.RTTI_Quantity,
            valueAttachment: RTTI_Attachment_1.RTTI_Attachment,
            valueReference: RTTI_Reference_1.RTTI_Reference,
            reason: RTTI_Coding_1.RTTI_Coding
        })
    ]);
});
//# sourceMappingURL=RTTI_ExplanationOfBenefit_SupportingInfo.js.map